import { render, staticRenderFns } from "./CreateBank.vue?vue&type=template&id=1c1ebdfe&"
import script from "./CreateBank.vue?vue&type=script&lang=js&"
export * from "./CreateBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports